import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';
import { A01Output } from 'api/U002';
import {
  cleanGoogleTagBody,
  cleanGoogleTagHeader,
  injectGoogleTagBody,
  injectGoogleTagHeader,
} from './utils';
type GoogleTagValue = {
  googletag?: string;
  googletag2?: string;
};
type AuditionFormGoogleTagContextValue = {
  value: GoogleTagValue;
  setValue: Dispatch<SetStateAction<GoogleTagValue>>;
};
export const AuditionFormGoogleTagContext = createContext<AuditionFormGoogleTagContextValue>({
  value: {},
  setValue: () => {},
});

const GoogleTagProvider: FC<PropsWithChildren> = ({ children }) => {
  const [googletag, setGoogletag] = useState<GoogleTagValue>({});

  useEffect(() => {
    if (!googletag.googletag || !googletag.googletag2) {
      return;
    }
    const header = injectGoogleTagHeader(googletag.googletag);
    const body = injectGoogleTagBody(googletag.googletag2);
    return () => {
      cleanGoogleTagHeader(header);
      cleanGoogleTagBody(body);
    };
  }, [googletag]);

  const contextValue: AuditionFormGoogleTagContextValue = {
    value: googletag,
    setValue: setGoogletag,
  };
  return (
    <AuditionFormGoogleTagContext.Provider value={contextValue}>
      {children}
    </AuditionFormGoogleTagContext.Provider>
  );
};

type GoogleTagProps = {
  [K in Extract<keyof A01Output, 'googletag' | 'googletag2'>]: A01Output[K];
};
const GoogleTagRegister: FC<GoogleTagProps> & {
  Provider: typeof GoogleTagProvider;
} = ({ googletag, googletag2 }) => {
  const { setValue } = useContext(AuditionFormGoogleTagContext);
  useEffect(() => {
    const parsedGoogletag = googletag;
    const parsedGoogletag2 = googletag2;
    setValue({
      googletag: parsedGoogletag,
      googletag2: parsedGoogletag2,
    });
    return () => {
      setValue({});
    };
  }, [googletag, googletag2]);

  return null;
};

GoogleTagRegister.Provider = GoogleTagProvider;

/**
 * このコンポーネントがレンダリングされると、
 * headとbodyにgoogletagを挿入される
 */
export const GoogleTag = GoogleTagRegister;
